import React from "react";

import styles from "./index.module.scss";
import { Modal } from "../modal";
import { Button } from "../../atoms/button";

interface Props {
  textDescription: string;
  cancelLabel: string;
  confirmLabel: string;
  onConfirm: () => void;
  isOpen: boolean;
  onCloseRequest: () => void;
}

const ConfirmModal: React.FC<Props> = ({
  isOpen,
  onCloseRequest,
  cancelLabel,
  confirmLabel,
  textDescription,
  onConfirm,
}) => {
  return (
    <Modal isOpen={isOpen} onCloseRequest={onCloseRequest}>
      <div className={styles.modalBody}>
        <div className={styles.title}>{textDescription}</div>
        <div className={styles.buttonsContainer}>
          <Button
            color="secondary"
            className={styles.button}
            onClick={onCloseRequest}
          >
            {cancelLabel}
          </Button>
          <Button className={styles.button} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export { ConfirmModal };
